.companyName {
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  word-break: break-all;
}
